import React from 'react';
import TabComponentChangeOrders from '../components/TabComponentChangeOrders';

//Unused view created for a previous requirement that may be will be back later
const ChangeOrders = () => {
  return (
    <div style={{marginTop: '10px'}}>
      {/* <TabComponentChangeOrders></TabComponentChangeOrders> */}
    </div>
  );
};

export default ChangeOrders;